<div class="container-fluid p-2 my-transport" *ngIf="transportOrder">
  <div class="page-title mb-4">
    <h2 class="inline">
      <jhi-bary-icon icon="chevron-left" [faDirective]="FAS" size="sm" role="button" (click)="previousState()"></jhi-bary-icon>
      <span *ngIf="transportOrder && transportOrder.id">Transport OT{{ transportOrder.id }}</span>
    </h2>
  </div>
  <jhi-transport-view [transportOrder]="transportOrder!" [savMail]="savMail"></jhi-transport-view>
  <div class="col-12">
    <div class="alert alert-info w-100">
      <jhi-bary-icon icon="question-circle" [faDirective]="FAS"></jhi-bary-icon>
      <span>Une question, une demande, n'hésitez pas à contacter le service après-vente en cliquant sur le lien : </span>
      <jhi-bary-link (click)="callSAV()" [label]="'Contacter le service après-vente'"></jhi-bary-link>
    </div>
  </div>
</div>
